// extracted by mini-css-extract-plugin
export default {"root":"ActionsPage_root__1cHNq","actions":"ActionsPage_actions__c57zu","buttons":"ActionsPage_buttons__clw3G","title":"ActionsPage_title__fTY6-"};